import React from "react";
import { Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

export default function Footer() {

  const navigate = useNavigate();

  return (
    // <!-- Footer -->
    <footer className="new_footer bg-gradient-custom"
      style={{}}
    >
      {/* CTA Section */}
      <div
        id="contact-us"
        className=" new_footer_outer_container container_new wow animate__animated animate__fadeInUp overflow-hidden text-white bg-center bg-no-repeat bg-cover"
      // style={{
      //   backgroundImage: "url('assets/images/CTA.png')",
      //   top: -300,
      //   left: 0, 
      //   right: 0,
      //   borderRadius: '60px',
      //   backgroundRepeat: 'no-repeat',
      //   width: "100%",
      //   // maxWidth: "1260px",
      //   // margin: "0 auto",
      //   position: 'absolute'
      // }}
      >
        <div className="new_floating_content_container d-flex flex-column flex-md-row align-items-center justify-content-between"
        >
          <div className=" new_floating_content  mb-3 mb-md-0">
            <h1 className=" fw-bold text-black lh-tight" style={{ fontFamily: "Inter, sans-serif" }}>
              Make Every Tech Investment Count.
            </h1>
            <p className="text-black "
              style={{ fontSize: 18, lineHeight: "22px", paddingTop: 16, paddingBottom: 35 }}
            >
              Start using Paybacck today—risk-free—and see how fast, clear investment decisions can transform your roadmap.
            </p>
            <button
              onClick={() => navigate('/sign')}
              className="primary-button primary-button-start-free position-relative">
              Start Free • No Credit Card Needed
            </button>
          </div>
          <div>
            <img src="assets/images/Dashboard.png" alt="Dashboard" className="rounded-3" />
          </div>
        </div>
      </div>

      {/* Footer Links Section */}
      <div className="text-white new_footer_links_outer_container " style={{
        // background: 'linear-gradient(134.93deg, #00002C -4.41%, #00308C 104.27%)'
        // paddingTop: 200
      }}>
        <div className="container_new">
          <div className="new_footer_links_container d-flex justify-content-between flex-column flex-lg-row">
            {/* Logo & Contact Info */}
            <div className="logo_contact_info">
              <a className="f_logo" href="#home" style={{ margin: 'auto', width: '100%', display: 'block' }}>
                <img
                  src="assets/icons/Paybacck.svg"
                  alt="Paybacck Logo"
                  className="mb-3"
                  style={{ height: "40px", width: "auto" }}
                />
              </a>
              <p className="fw-semibold "
                style={{ paddingTop: 40, fontSize: 16, paddingBottom: 20 }}
              >Offices</p>
              <p className="fs-4 "
                style={{ color: '#fff', z: 0.7, lineHeight: 1.625 }}
              >
                5700 Tennyson Parkway Suite 300, Plano, TX, 75024 USA
              </p>
              <p className="fw-medium fs-4"
                style={{ paddingTop: 20, paddingBottom: 12 }}
              >Drop us a line</p>
              <a
                href="mailto:info@Paybacck.com"
                className="text-primary text-decoration-underline fs-4 break-all"
              >
                info@Paybacck.com
              </a>
            </div>

            {/* Quick Links */}
            <div className="" style={{ flex: 1 }}>
              <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 g-3">
                {/* Column: Quick Links */}
                <div>
                  <p className="fw-semibold fs-3">Quick Links</p>
                  <ul className="list-unstyled " style={{ marginTop: 24 }} >
                    {[
                      { link: '/', name: "Home" },
                      { link: '#features', name: "Features" },
                      { link: '#services', name: "Services" },
                      { link: '#about-us', name: "About Us" },
                      { link: '#pricing', name: "Pricing" },
                      { link: '#faq', name: "FAQ" }
                    ].map((link, i) => (
                      <li key={i}>
                        <Link to={link.link == "/" ? "/"  : "/home" + link.link} className="text-decoration-none d-block py-1" style={{ fontSize: 15 }}>
                          {link.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Column: Company */}
                <div>
                  <p className="fw-semibold fs-3">Company</p>
                  <ul className="list-unstyled pt-3">
                    {[
                      {link:"#about-us", name:"About"},
                      {link:"#careers", name:"Careers"},
                      {link:"#press", name:"Press"},
                      // {link:"#blog", name:"Blog"},
                      {link:"#events", name:"Events"},
                      {link:"#partnerships", name:"Partnerships"}
                    ].map((link, i) => (
                      <li key={i}>
                        <Link to={"/home" + link.link} className="text-decoration-none d-block py-1" style={{ fontSize: 15 }}>
                          {link.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Column: Resources */}
                <div>
                  <p className="fw-semibold fs-3">Resources</p>
                  <ul className="list-unstyled pt-3">
                    {[
                      // { name: "Support Center", link: "#support-center" },
                      { name: "Knowledge Base", link: "#knowledge-base" },
                      { name: "Video Tutorials", link: "#video-tutorials" },
                      { name: "Case Studies", link: "#case-studies" },
                      { name: "White Papers", link: "#white-papers" },
                      // { name: "E-books", link: "#e-books" },
                      { name: "Tutorials", link: "#tutorials" },
                    ].map((link, i) => (
                      <li key={i}>
                        <Link to={"/home" + link.link} className="text-decoration-none d-block py-1" style={{ fontSize: 15 }}>
                          {link.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Column: Product */}
                <div>
                  <p className="fw-semibold fs-3">Product</p>
                  <ul className="list-unstyled pt-3">
                    {[
                      // { name: "Dashboard Overview", link: "#dashboard-overview" },
                      // { name: "Integration Options", link: "#integration-options" },
                      // { name: "API Documentation", link: "#api-documentation" },
                      { name: "Security Features", link: "#security-features" },
                      // { name: "Feature Roadmap", link: "#feature-roadmap" },
                      // { name: "Product Updates", link: "#product-updates" },
                      // { name: "Mobile Access", link: "#mobile-access" },
                      // { name: "Demo Videos", link: "#demo-videos" },
                    ].map((link, i) => (
                      <li key={i}>
                        <Link to={"/home" + link.link} className="text-decoration-none d-block py-1" style={{ fontSize: 15 }}>
                          {link.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="container_new bottom_footer"  >
          <div className="d-flex flex-column flex-md-row align-items-center justify-content-between ">
            <p className="fs-4 fw-bold">&copy; 2025, Paybacck</p>
            <div className="d-flex align-items-center gap-5 mt-3 mt-md-0">
              {/* {[
                { src: "x.svg", alt: "x" },
                { src: "instragram.svg", alt: "instagram" },
                { src: "fb.svg", alt: "facebook" },
                { src: "tiktok.svg", alt: "tiktok" },
                { src: "p.svg", alt: "pinterest" },
              ].map((icon, i) => (
                <a href="#" key={i} className="d-inline-block">
                  <img src={`assets/icons/${icon.src}`} alt={icon.alt} />
                </a>
              ))} */}
            </div>
          </div>
        </div>
      </div>
    </footer>

  )
}